module.exports = __webpack_public_path__ + "static/customer-service-aa7c830649f394100971716e116046f7.png";